export default __webpack_public_path__ + "static/media/close.df425836.svg";